<form [formGroup]="airlinePlbForm" class="ledger-filter-form">
    <div class="flexbox aff-info">
      <div class="flexbox aff-info-inner w-100">
        <div class="flexbox w-100">
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="1" formControlName="start_date" id="from_date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !airlinePlbForm.controls.end_date.valid}"
                />
            <label for="from_date">Starting Date</label> -->

            <ng-container *ngIf="isLocaleDateFormat">
              <input class="input-ui" searchtabindex="1" formControlName="start_date" id="date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !airlinePlbForm.controls.start_date.valid}"
                 />
            </ng-container>

            <ng-container *ngIf="!isLocaleDateFormat && airlinePlbForm.controls.start_date">
                <app-date-time-input
                formControlName="start_date"
                [dateFormat]="dateFormat"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [fieldController]="airlinePlbForm.controls.start_date"
                class="new-date-input"
                classes="inv-date-input" 
                tIndex="1"
                ></app-date-time-input>
            </ng-container>
            <label for="date">From Date</label>
  
          </div>
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="2" formControlName="end_date" id="to_date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !airlinePlbForm.controls.end_date.valid}"
                /> -->

            <ng-container *ngIf="isLocaleDateFormat">
              <input class="input-ui" searchtabindex="2" formControlName="end_date" id="date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !airlinePlbForm.controls.end_date.valid}"
                 />
            </ng-container>
            <ng-container *ngIf="!isLocaleDateFormat && airlinePlbForm.controls.end_date">
                <app-date-time-input
                formControlName="end_date"
                [dateFormat]="dateFormat"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [fieldController]="airlinePlbForm.controls.end_date"
                class="new-date-input"
                classes="inv-date-input" 
                tIndex="2"
                ></app-date-time-input>
            </ng-container>
            <label for="date">To Date</label>

            <!-- <label for="to_date">Ending Date</label> -->
          </div>
        </div>
  
        <div class="flexBox d-flex mt-20 mr-2">
         
          <div class="select-field text-input-fiel">
            <select class="input-field" searchtabindex="5" formControlName="account_type">
              <option value="none">None</option>
              <option value="client">Client</option>
              <option value="airline">Airline</option>
              <option value="supplier">Supplier</option>
            </select>
            <label for="account_type">Account Type</label>
          </div>
        </div>
  
        <div class="d-flex mt-5 justify-content-center">
          <div class="input-fiel">
            <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
              searchtabindex="3" #searchButton (keyup.enter)="clickSearchButton()"
              [disabled]="airlinePlbForm.invalid"
              (click)="search(airlinePlbForm.value)">
              Search</button>
            <button type="button" class="btn-style bg-green" id="resetSearchForm" (click)="reset()">RESET</button>
          </div>
        </div>
      </div>
    </div>
  </form>